import { createSlice } from "@reduxjs/toolkit";
import {
  getOrders,
  addNewOrder,
  updateOrder,
  cancelOrder,
  getInvoice,
} from "./thunk";
import { toast } from "react-toastify";
export const initialState = {
  orders: [],
  error: {},
  orderPlaced: false,
  pagination: {
    currentPage: 0,
    pageSize: 50,
    totalItems: 0,
    totalPages: 0,
    total: 0,
    totalActive: 0,
    totalCancelled: 0,
    totalFavorites: 0,
    totalHidden: 0,
    totalInStock: 0,
    totalInactive: 0,
    totalOrdered: 0,
    totalOutOfStock: 0,
    totalPendingOrders: 0,
    totalReady: 0,
    totalStockNotifications: 0,
  },
};

const OrdersSlice = createSlice({
  name: "OrdersSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getOrders.fulfilled, (state, action) => {
      state.orders = action.payload.data;
      state.pagination = action.payload.pagination;
    });

    builder.addCase(getOrders.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(addNewOrder.fulfilled, (state, action) => {
      if (action.payload.success) {
        state.orders.push(action.payload);
        document.location.href = "/orders";
      }
    });

    builder.addCase(addNewOrder.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(updateOrder.fulfilled, (state, action) => {
      const index = state.orders.findIndex(
        (order) => order.id === action.payload.id
      );
      state.orders[index] = action.payload;
    });

    builder.addCase(updateOrder.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(cancelOrder.fulfilled, (state, action) => {
      state.orderPlaced = true;
      const index = state.orders.findIndex(
        (order) => order.ord_id === action.payload.data.ordId
      );
      if (index !== -1) {
        state.orders[index] = {
          ...state.orders[index],
          ord_status: action.payload.data.ordStatus,
        };
      }
    });

    builder.addCase(getInvoice.pending, (state) => {
      toast.dismiss();

      state.error = null;
    });

    builder.addCase(getInvoice.fulfilled, (state, action) => {
      if (action.payload.success) {
        window.open(action.payload.data, "_blank");
      } else {
        toast.dismiss();
        toast.error(action.payload.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
    });
    builder.addCase(getInvoice.rejected, (state, action) => {
      toast.dismiss();
      toast.error(action, {
        position: "top-center",
        autoClose: 3000,
      });
    });
  },
});

export default OrdersSlice.reducer;
